import { authRequest } from "src/engine/modules/authRequest"

// Спека https://next.stoplight.io/infotech-group/planner/version%2F1.0/main.oas2.yml?view=/permissions
// Реализовывать другие методы по необходимости

export const getPermissions = ({ query, orderBy, offset, limit } = {}) =>
  authRequest({
    url: `/auth/permissions`,
    params: {
      query,
      orderBy,
      offset,
      limit,
    },
  })

export const getRolePermissions = ({ role, query, orderBy, offset, limit }) =>
  authRequest({
    url: `/auth/roles/${role}/permissions`,
    params: {
      query,
      orderBy,
      offset,
      limit,
    },
  })

export const setRolePermissions = ({ role, permissions }) =>
  authRequest({
    url: `/auth/roles/${role}/permissions`,
    method: `post`,
    data: permissions,
  })

export const getCurrentUserPermissions = ({
  query,
  orderBy,
  offset,
  limit,
} = {}) =>
  authRequest({
    url: `/auth/users/current/permissions`,
    params: {
      query,
      orderBy,
      offset,
      limit,
    },
  })
